import { useEffect, useState } from 'react';
import { useSettings } from '../../services/entities/hooks/settings/useSettings';
import { useTranslation } from '../../services/translation/hooks/useTranslation';

/**
 * Get user settings and update the language of the translation service
 */
export const useInitSettings = () => {
  const { settings, isSettingsLoading } = useSettings();
  const { language, setLanguage } = useTranslation();
  const [settingsInitialized, setSettingsInitialized] = useState(false);

  useEffect(() => {
    if (!isSettingsLoading && language !== settings?.language) {
      setLanguage(settings?.language);
    }
  }, [language, settings?.language, setLanguage, isSettingsLoading]);

  useEffect(() => {
    if (!isSettingsLoading) {
      setSettingsInitialized(true);
    }
  }, [isSettingsLoading]);

  return settingsInitialized;
};
